export const MODULE_NAVIGATION_STORAGE_KEY = "mea.moduleNavigationState";
export const MODULE_NAVIGATION_MAX_AGE_MS = 5 * 60 * 1000;

const pathnameOf = (target) => {
  const value = typeof target === "string" ? target : target?.pathname || "";
  return value.split(/[?#]/, 1)[0] || "/";
};

export const isMeaOpsRoute = (target) => {
  const pathname = pathnameOf(target);
  return pathname === "/ops" || pathname.startsWith("/ops/");
};

const storeModuleNavigationState = (target, state) => {
  if (typeof sessionStorage === "undefined") return;
  try {
    if (!state) {
      sessionStorage.removeItem(MODULE_NAVIGATION_STORAGE_KEY);
      return;
    }
    sessionStorage.setItem(
      MODULE_NAVIGATION_STORAGE_KEY,
      JSON.stringify({
        target: pathnameOf(target),
        state,
        createdAt: Date.now(),
      }),
    );
  } catch (error) {
    // Handoff state is optional; navigation must continue if storage is unavailable.
    console.warn(
      "Unable to save module navigation state; continuing navigation.",
      error,
    );
  }
};

export const navigateFromPlatform = (
  navigate,
  target,
  { replace = false, ...routerOptions } = {},
) => {
  if (!isMeaOpsRoute(target)) {
    navigate(target, { replace, ...routerOptions });
    return;
  }

  storeModuleNavigationState(target, routerOptions.state);

  if (replace) {
    window.location.replace(target);
  } else {
    window.location.assign(target);
  }
};

export const readModuleNavigationState = (
  target,
  storage = sessionStorage,
  now = Date.now(),
) => {
  try {
    const rawValue = storage.getItem(MODULE_NAVIGATION_STORAGE_KEY);
    if (!rawValue) return null;
    const value = JSON.parse(rawValue);
    if (
      value?.target !== pathnameOf(target) ||
      !Number.isFinite(value?.createdAt) ||
      now - value.createdAt > MODULE_NAVIGATION_MAX_AGE_MS
    ) {
      return null;
    }
    return value.state || null;
  } catch {
    return null;
  }
};

export const clearModuleNavigationState = (storage = sessionStorage) => {
  storage.removeItem(MODULE_NAVIGATION_STORAGE_KEY);
};
